{
  "type": "object",
  "properties": {
    "SamplingFrequency": { "type": "number", "exclusiveMinimum": 0 },
    "StartTime": { "type": "number" },
    "Columns": {
      "type": "array",
      "items": {
        "type": "string",
        "minLength": 1
      }
    },
    "Manufacturer": { "type": "string" },
    "ManufacturersModelName": { "type": "string" },
    "SoftwareVersions": { "type": "string" },
    "DeviceSerialNumber": { "type": "string" }
  },
  "required": ["SamplingFrequency", "StartTime", "Columns"]
}
